export default "__VITE_ASSET__Ev8TlOVC__"